export const ACTION_RESET = 'FETCH_EXHIBITOR_RESET';
export const ACTION_REQUEST = 'FETCH_EXHIBITOR_REQUEST';
export const ACTION_SUCCESS = 'FETCH_EXHIBITOR_SUCCESS';
export const ACTION_ERROR = 'FETCH_EXHIBITOR_ERROR';
